import { fetch } from '../../utils';
import Backend from '../../backend';

//API TO ADD THE CLIENT ON CLIENT VIEW
export const submitClient = data => {
  return fetch(Backend.methodUrl('submitClient'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API TO ENABLE THE TRACKING OF CLIENT
export const enableTracking = data => {
  return fetch(Backend.methodUrl('enableTracking'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API TO GET THE CLIENT OF LOGIN ADVISER
export const getClient = () => {
  let sortBy = localStorage.getItem('clientSortBy');
  localStorage.removeItem('clientSortBy');
  return fetch(Backend.methodUrl(sortBy ? `getClient?sortBy=${sortBy}` : 'getClient'), { method: 'GET' })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API TO CHECK THE CLIENT IS EXIST OR NOT WHILE ADDING THE CLIENT
export const checkClient = data => {
  return fetch(Backend.methodUrl('checkClient'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API TO DELETE THE CLIENT FROM CLIENT VIEW
// Rejects instead of resolving to `{ error }` (as submitClient above already
// does). Swallowing the rejection made every transport failure look like a
// successful delete to the epic, which then cleared the client out of local
// storage while the server had done nothing. The server answers 200/422/500 —
// all three carry a readable body through utils/fetch.js — so a rejection here
// means the request never got an answer at all.
//
// `factsheetId` is no longer sent: the server re-derives it from the database
// (it must, or a disconnected client's delete orphans the factsheet).
//
// The v2 path is what makes dropping the parameter safe. The old handler trusted
// it, and a request without one collapsed `{ _id: undefined }` into `{}`,
// deleting an arbitrary factsheet from the whole collection. A server rolled
// back past that fix has no v2 route, so this 404s — utils/fetch.js throws on
// it, the epic keeps the client and reports the failure, and nothing is
// deleted. Do not point this back at /deleteClient to "be compatible": that is
// the exact call that would destroy another adviser's data.
export const deleteClient = data => {
  return fetch(Backend.methodUrl('deleteClientV2') + `/${data.clientId}`, {
    method: 'DELETE'
  }).then(res => {
    return res.json();
  });
};

//API TO GET THE CLIENT DETAIL
export const getClientDetails = data => {
  const factsheetId = data.factsheetId;
  const userId = data.userId;
  return fetch(Backend.methodUrl('getClientDetails') + `/${factsheetId}/${userId}`, {
    method: 'GET'
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API TO SEND THE CONSENT TO THE CLIENT
export const getConsent = data => {
  return fetch(Backend.methodUrl('getConsent'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API TO SUBMIT THE CONSENT
export const submitConsent = data => {
  return fetch(Backend.methodUrl('submitConsent'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      return { error };
    });
};

//API TO UPDATE THE FACTSHEET DETAIL
export const updateFactSheet = data => {
  return fetch(Backend.methodUrl('updateFactSheet'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API THE CHNAGE THE EMAIL  OF INACTIVE USER
export const changeInactiveUserEmail = data => {
  return fetch(Backend.methodUrl('changeInactiveUserEmail'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API TO UPDATE THE CLIENT LANGUAGE
export const updateClientLanguage = data => {
  return fetch(Backend.methodUrl('updateLanguage'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

export const getClientCoverage = data => {
  const userId = data.userId;
  return fetch(Backend.methodUrl('getClientCoveragePolicy') + `/${userId}`, {
    method: 'GET'
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

//API TO CREATE DEMO CLIENT
export const createDemoClient = data => {
  return fetch(Backend.methodUrl('createDefaultClient'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

export const editPortfolio = data => {
  return fetch(Backend.methodUrl('editPortfolio'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

export const changeDemoClient = clientId => {
  return fetch(Backend.methodUrl(`changeDemoClient/${clientId}`))
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

export const adviserExport = ({ password }) => {
  return fetch(Backend.methodUrl('adviser-export'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ password })
  })
    .then(res => {
      if (res.status === 200) {
        return res.blob();
      } else {
        throw new Error('Something went wrong');
      }
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

export const getClientById = clientId => {
  return fetch(Backend.methodUrl(`clients/${clientId}`))
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

export const getFactsheet = factsheetId => {
  return fetch(Backend.methodUrl(`getFactsheet?factsheetId=${factsheetId}`))
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

export const updateFactsheetById = data => {
  return fetch(Backend.methodUrl('updateFactsheetById'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }, 
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};
